import { atom } from 'recoil';
import AuthManager from '../../../shared/auth-manager';

const $isLogin = atom<boolean>({
    key: '@login/is-login',
    default: new AuthManager().isLogin(),
});

export default $isLogin;
